/* global visualSwings, data, serverParams */
import React from 'react'
import { render } from 'react-dom'
import type Swing from './types/Swing.ts'

import App from './App.tsx'
import { SwingPathData } from './types/globals.ts'

const swingPathData = data as SwingPathData[]

function idFunction(
    playerId: number | string,
    year: number | string,
    batSide: string
) {
    return `${playerId}-${year}-${batSide}`
}

function sortOrder(a: Swing, b: Swing) {
    if (a.name !== b.name) {
        return a.name > b.name ? 1 : -1
    }

    return a.year > b.year ? -1 : 1
}

const $app = document.getElementById('app')

const swings: Swing[] = visualSwings
    .map((p) => ({
        ...p,
        lastName: p.name.split(',')[0],
        id: idFunction(p.playerId, p.year, p.batSide),
    }))
    .sort(sortOrder)

const seasons = [serverParams.seasonEnd]

let i = serverParams.seasonEnd
while (i > serverParams.seasonStart) {
    i -= 1
    seasons.push(i)
}

const possibleArr = swingPathData.flatMap((row) => {
    const sides = Number(row.n_sides) === 2 ? ['L', 'R'] : [row.side]
    const ids = seasons
        .map((season) =>
            sides.map((side) => idFunction(row.savant_batter_id, season, side))
        )
        .flat()

    return ids
})

const possibleIds = new Set(possibleArr)

const relevantSwings = visualSwings
    .filter((d) => {
        const id = idFunction(d.playerId, d.year, d.batSide)
        return possibleIds.has(id)
    })
    .map((p) => ({
        ...p,
        lastName: p.name.split(',')[0],
        id: idFunction(p.playerId, p.year, p.batSide),
    }))
    .sort(sortOrder)

const relevantIds = new Set(relevantSwings.map((d) => d.id))

if ($app) {
    const url = new URL(window.location.href)
    const playerListStr = url.searchParams.get('playerList')
    const selectedIdxStr = url.searchParams.get('selectedIdx')

    let playerList: Swing[] = []
    let selectedIdx = 0

    if (playerListStr) {
        const swingIds = playerListStr.split(',')
        playerList = swings.filter((d) => swingIds.includes(d.id))
    }

    if (!playerList.length) {
        const swingId = possibleArr.find((d) => relevantIds.has(d))

        if (swingId) {
            const swing = swings.find((d) => d.id === swingId)
            if (swing) {
                playerList = [swing]
            }
        }

        if (!playerList.length) {
            if (serverParams.seasonEnd === 2024) {
                playerList = swings.filter((d) => d.id === '677594-2024-R')
            } else if (serverParams.seasonEnd === 2023) {
                playerList = swings.filter((d) => d.id === '677594-2024-R')
            } else {
                playerList = swings.filter((d) => d.id === '660271-2025-L')
            }
        }
    }

    if (selectedIdxStr && Number(selectedIdxStr)) {
        selectedIdx = Number(selectedIdxStr)
    }
    render(
        <App
            swings={swings}
            relevantSwings={relevantSwings}
            initPlayerList={playerList}
            initSelectedIdx={selectedIdx}
        />,
        $app
    )
}
